export enum DateComparison {
  NotEarlierThan = 'notEarlierThan',
  NotLaterThan = 'notLaterThan',
}
